<template>
  <div class="w-screen h-screen flex flex-col overflow-auto">
    <div class="flex">
      <h2 class="text-primary mx-auto my-auto text-xl md:text-5xl">
        Publicar nuevo producto de Salud
      </h2>
    </div>
    <div class="w-full max-w-lg p-2 mx-auto">
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full md:w-1/2 px-3 mb-2 md:mb-0">
          <label
            class="
              block
              uppercase
              tracking-wide
              text-gray-700 text-xs
              font-bold
              mb-2
            "
            for="grid-first-name"
          >
            Nombre
          </label>
          <input
            class="
              appearance-none
              block
              w-full
              bg-gray-200
              text-gray-700
              border border-red-500
              rounded
              py-3
              px-4
              mb-3
              leading-tight
              focus:outline-none focus:bg-white
            "
            id="grid-first-name"
            type="text"
            placeholder=""
            v-model="nombre"
          />
          <p class="text-red-500 text-xs italic">Porfavor llenar este campo.</p>
        </div>
      </div>
      <div class="w-full flex flex-wrap">
        <div class="w-full md:w-1/2 px-2 flex flex-col">
          <label
            class="
              block
              flex flex-row
              uppercase
              tracking-wide
              text-xs
              font-bold
              mb-2
            "
            for="grid-zip"
          >
            Cantidad (Stock Cios)
          </label>
          <div class="flex flex-row mx-auto">
            <button class="focus:outline-none" @click="restar">
              <span class="material-icons my-auto p-1 text-2xl text-primary"
                >remove_circle</span
              >
            </button>
            <input
              class="
                appearance-none
                block
                w-1/4
                bg-gray-200
                text-gray-700
                border border-gray-200
                rounded
                my-2
                py-3
                px-4
                leading-tight
                focus:outline-none focus:bg-white focus:border-gray-500
              "
              id="grid-zip"
              type="number"
              :placeholder="calculo"
              v-model="numerito"
            />
            <span class="my-auto text-3xl" v-if="false">{{ calculo }}</span>

            <button class="focus:outline-none" @click="sumar">
              <span class="material-icons my-auto p-1 text-2xl text-primary"
                >add_circle</span
              >
            </button>
          </div>
        </div>
        <div class="w-full md:w-1/2 px-2 flex flex-col">
          <label
            class="
              block
              flex flex-row
              uppercase
              tracking-wide
              text-xs
              font-bold
              mb-2
            "
            for="grid-zip"
          >
            Cantidad (Stock Caracas)
          </label>
          <div class="flex flex-row mx-auto">
            <button class="focus:outline-none" @click="restar2">
              <span class="material-icons my-auto p-1 text-2xl text-primary"
                >remove_circle</span
              >
            </button>
            <input
              class="
                appearance-none
                block
                w-1/4
                bg-gray-200
                text-gray-700
                border border-gray-200
                rounded
                my-2
                py-3
                px-4
                leading-tight
                focus:outline-none focus:bg-white focus:border-gray-500
              "
              id="grid-zip"
              type="number"
              :placeholder="calculo2"
              v-model="numerito2"
            />
            <span class="my-auto text-3xl" v-if="false">{{ calculo2 }}</span>

            <button class="focus:outline-none" @click="sumar2">
              <span class="material-icons my-auto p-1 text-2xl text-primary"
                >add_circle</span
              >
            </button>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
        <div class="w-full px-3">
          <label
            class="
              block
              uppercase
              tracking-wide
              text-gray-700 text-xs
              font-bold
              mb-2
            "
            for="grid-password"
          >
            DescripciÓn
          </label>
          <input
            class="
              appearance-none
              block
              w-full
              bg-gray-200
              text-gray-700
              border border-gray-200
              rounded
              py-3
              px-4
              mb-3
              leading-tight
              focus:outline-none focus:bg-white focus:border-gray-500
            "
            id="grid-description"
            type="text"
            v-model="descripcion"
          />
          <p class="text-gray-600 text-xs italic">
            Tan extensa y loca como deseen.
          </p>
        </div>
      </div>
      <div class="w-full max-w-lg mx-auto" v-if="false">
        <label
          class="
            block
            uppercase
            tracking-wide
            text-gray-700 text-xs
            font-bold
            mb-2
          "
          for="grid-state"
        >
          Venta o Alquiler
        </label>
        <div class="relative">
          <select
            class="
              block
              appearance-none
              w-full
              bg-secondary
              border border-primary
              text-primary
              py-3
              px-4
              pr-8
              rounded
              leading-tight
              focus:text-secondary
              focus:text-opacity-75
              focus:outline-none
              focus:bg-primary
              focus:border-secondary
            "
            id="grid-state"
            v-model="tipo"
          >
            <option>Alquiler</option>
            <option>Venta</option>
          </select>
          <div
            class="
              pointer-events-none
              absolute
              inset-y-0
              right-0
              flex
              items-center
              px-2
              text-primary
            "
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
      </div>
      <!--div class="flex flex-wrap -mx-3 mb-2 mt-2">

                <div class="w-full md:w-1/2 px-3 mb-6 md:my-2 ">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                        Venta o Alquiler
                    </label>
                    <div class="relative">
                        <select class="block appearance-none w-full bg-secondary border border-primary text-primary py-3 px-4 pr-8 rounded leading-tight focus:text-secondary focus:text-opacity-75 focus:outline-none focus:bg-primary focus:border-secondary" id="grid-state" >
                            <option>Alquiler</option>
                            <option>Venta</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-primary">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
            </div-->
      <div class="w-full items-center justify-center flex">
        <img :src="imageUrl" style="max-height: 6rem" class="m-2" />
      </div>
      <div class="mb-24 md:flex md:items-center md:mb-0">
        <input
          type="file"
          style="display: none"
          ref="fileInput"
          accept="image/*"
          @change="onFilePicked"
        />
        <div class="md:w-2/3 flex justify-center md:justify-start">
          <button
            class="
              shadow
              bg-primary
              hover:bg-purple-400
              focus:shadow-outline focus:outline-none
              text-secondary
              font-bold
              py-2
              px-4
              rounded
            "
            type="button"
            @click="onPickFile"
          >
            <div class="flex">
              Imagen
              <span class="material-icons text-secondary mx-1">attachment</span>
            </div>
          </button>
        </div>
        <div class="my-2 md:w-1/3 flex justify-center md:justify-end">
          <button
            class="
              shadow
              border border-primary
              focus:shadow-outline focus:outline-none
              text-primary
              font-bold
              py-2
              px-4
              rounded
            "
            type="button"
            @click="onCreate"
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
    <div v-if="progress != null" class="mx-auto my-16 relative flex">
      <div class="w-32 h-32 flex">
        <div
          style="border-top-color: transparent"
          class="
            animate-spin
            absolute
            rounded-full
            border-8 border-t-8
            h-32
            w-32
          "
        ></div>
        <h1 class="mx-auto my-auto text-3xl font-bold">{{ parseInt(progress) }}%</h1>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
//import Carousel from '@/components/admin/carousel-admin.vue'
export default {
  components: {
    //Carousel
  },
  data() {
    return {
      isOpen: false,
      nombre: "",
      image: null,
      imageUrl: "",
      descripcion: "",
      tipo: "Alquiler",
      numerito: "",
      cantidad: 0,
      numerito2: "",
      cantidad2: 0,
    };
  },
  computed: {
    ...mapGetters(["getLoading", "getprogress"]),
    formIsValid() {
      return (
        this.nombre !== "" && this.descripcion !== "" && this.imageUrl !== ""
      );
    },
    cargando() {
      return this.getLoading;
    },
    progress() {
      return this.getprogress;
    },
    calculo() {
      if (this.numerito == "") return this.cantidad;
      else return this.numerito;
    },
    calculo2() {
      if (this.numerito2 == "") return this.cantidad2;
      else return this.numerito2;
    },
  },
  methods: {
    ...mapActions(["newSalud"]),
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
    },
    onCreate() {
      if (!this.formIsValid) {
        this.$store.commit("showMessage", {
          content: "Faltan datos del producto!",
          color: "error",
        });
        return;
      }
      if (!this.image) {
        this.$store.commit("showMessage", {
          content: "No ha incluido una imagen de producto.",
          color: "error",
        });
        return;
      }
      const vestido = {
        nombre: this.nombre,
        image: this.image,
        descripcion: this.descripcion,
        tipo: this.tipo,
        cantidad: parseInt(this.calculo),
        cantidad2: parseInt(this.calculo2),
      };
      this.newSalud(vestido);
      this.nombre = "";
      this.descripcion = "";
      this.image = null;
      this.imageUrl = "";
      this.cantidad = 0;
      this.cantidad2 = 0;
      //this.$router.push('/')
    },
    sumar() {
      if (this.numerito != "") {
        this.numerito = parseInt(this.numerito) + 1;
        this.cantidad = 0;
      } else {
        this.cantidad = this.cantidad + 1;
        this.numerito = "";
      }
    },
    sumar2() {
      if (this.numerito2 != "") {
        this.numerito2 = parseInt(this.numerito2) + 1;
        this.cantidad2 = 0;
      } else {
        this.cantidad2 = this.cantidad2 + 1;
        this.numerito2 = "";
      }
    },
    restar() {
      if (this.numerito != "") {
        this.numerito = parseInt(this.numerito) - 1;
        this.cantidad = 0;
      } else {
        this.cantidad = this.cantidad - 1;
        this.numerito = "";
      }
    },
    restar2() {
      if (this.numerito2 != "") {
        this.numerito2 = parseInt(this.numerito2) - 1;
        this.cantidad2 = 0;
      } else {
        this.cantidad2 = this.cantidad2 - 1;
        this.numerito2 = "";
      }
    },
  },
};
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>